
import React from "react";
import ReactDOM from "react-dom";
import ModWebParts from './containers/ModWebParts';
//main container component
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
   
        return (
            // <div>
            //     <Layout webPartProperties={this.props.webPartProperties}>
         
                    <ModWebParts webPartProperties={this.props.webPartProperties} />
            //     </Layout>
            // </div>
        );
    }
}
export default App;
 